import React from 'react';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from '@mui/material';

interface TablePanelProps<T> {
  title: string;
  columns: { label: string; key: keyof T }[];
  data: T[];
  viewMore?: boolean;
  renderCell?: (key: keyof T, value: any, row: T) => React.ReactNode;
}

const TablePanel = <T,>({
  title,
  columns,
  data,
  viewMore = false,
  renderCell,
}: TablePanelProps<T>) => (
  <div className="cards table_cards">
    <div className="cards_header">
      <div className="left_s">
        <h2>{title}</h2>
      </div>
      <div className="right_s">
        {viewMore && (
          <Button className="btn sm btn_primary">View More</Button>
        )}
      </div>
    </div>
    <div className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((col) => (
              <TableCell key={String(col.key)}>{col.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, idx) => (
            <TableRow key={idx}>
              {columns.map((col) => (
                <TableCell key={String(col.key)}>
                  {renderCell
                    ? renderCell(col.key, row[col.key], row)
                    : (row[col.key] as string) || '-'}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  </div>
);

export default TablePanel;
